import React from 'react';
import { WhatIsATalentAgencyRoster } from './WhatIsATalentAgencyRoster';
import { TalentVsMarketingAgencies } from './TalentVsMarketingAgencies';
import { HowBrandsWorkWithTalentAgencies } from './HowBrandsWorkWithTalentAgencies';
import type { GuideSection } from './GuideToc';

/**
 * Maps a guide slug to its published article body.
 * Guides without an entry here render the "coming soon" placeholder.
 */
export const GUIDE_CONTENT: Record<string, () => JSX.Element> = {
  'what-is-a-talent-agency-roster': WhatIsATalentAgencyRoster,
  'talent-agencies-vs-marketing-agencies': TalentVsMarketingAgencies,
  'how-brands-work-with-talent-agencies': HowBrandsWorkWithTalentAgencies
};

/**
 * In-page table of contents per guide. Ids match the GuideH2 anchors
 * inside each article body.
 */
export const GUIDE_SECTIONS: Record<string, GuideSection[]> = {
  'what-is-a-talent-agency-roster': [{
    id: 'introduction',
    label: 'Introduction'
  }, {
    id: 'landscape',
    label: 'Understanding the influencer agency landscape'
  }, {
    id: 'what-is-a-roster',
    label: 'What is an influencer roster?'
  }, {
    id: 'types-of-representation',
    label: 'Types of representation'
  }, {
    id: 'how-agencies-present-rosters',
    label: 'How agencies present their rosters'
  }, {
    id: 'inside-a-roster',
    label: 'What information is inside a roster?'
  }, {
    id: 'traditional-roster-problems',
    label: 'The problem with traditional rosters'
  }, {
    id: 'final-thoughts',
    label: 'Final thoughts'
  }],
  'how-brands-work-with-talent-agencies': [{
    id: 'introduction',
    label: 'Introduction'
  }, {
    id: 'reality-today',
    label: 'The reality of influencer marketing today'
  }, {
    id: 'professionalism-and-scale',
    label: 'Why talent agencies unlock professionalism + scale'
  }, {
    id: 'where-it-still-breaks',
    label: 'Where it still breaks'
  }, {
    id: 'final-thoughts',
    label: 'Final thoughts'
  }],
  'talent-agencies-vs-marketing-agencies': [{
    id: 'introduction',
    label: 'Introduction'
  }, {
    id: 'industry-setup',
    label: 'The industry setup'
  }, {
    id: 'what-is-a-roster',
    label: 'What is an influencer roster (and why it matters)?'
  }, {
    id: 'strategy-vs-talent',
    label: 'The real difference: strategy vs. talent access'
  }, {
    id: 'high-quality-talent',
    label: 'What defines high-quality talent?'
  }, {
    id: 'when-to-work-with-each',
    label: 'When should you work with each?'
  }, {
    id: 'trade-offs',
    label: 'The trade-offs'
  }, {
    id: 'red-flags',
    label: 'Red flags to watch out for'
  }, {
    id: 'final-thoughts',
    label: 'Final thoughts'
  }]
};